export default __webpack_public_path__ + "static/media/filterIcon.95a99068.svg";